import {
    ADD_P24_MERCHANT,
    EDIT_P24_MERCHANT,
    DELETE_P24_MERCHANT,
    FETCH_P24_MERCHANTS,
    FETCH_P24_MERCHANT_BY_ID,
    FETCH_P24_MERCHANTS_BY_NIP,
    FETCH_P24_MERCHANTS_BY_PESEL,
    FETCH_P24_MERCHANTS_BY_P24_MERCHANT_ID,
    TEST_CONNECTION_P24_MERCHANT,
    FETCH_P24_MERCHANT_PAYMENT_METHODS
} from "../actions/actionTypes";

const defaultState = {
    //lista ze wszystkimi merchantami p24
    p24MerchantList: [],
    //test połączenia do konkretnego merchanta
    p24MerchantTestConnection: {},
    //metody płatności wybranego merchanta
    p24MerchantPaymentMethodList: [],
    //wyszukiwanie po nipie/peselu/p24MerchantId
    p24MerchantsByTaxId: {},
    //wyszukiwanie po id
    p24MerchantById: {},
};

export default function p24MerchantReducer(state = defaultState, action) {
    switch (action.type) {
        case FETCH_P24_MERCHANTS: {
            return {
                ...state,
                p24MerchantList: action.payload
            };
        }
        case ADD_P24_MERCHANT:
            return {
                ...state,
                p24MerchantList: [...state.p24MerchantList, action.payload]
            };
        case EDIT_P24_MERCHANT:
            return {
                ...state,
                p24MerchantList: state.p24MerchantList.map(merchant =>
                    merchant.id === action.payload.id ? action.payload : merchant
                )
            };
        case DELETE_P24_MERCHANT:
            return {
                ...state,
                p24MerchantList: state.p24MerchantList.filter(
                    merchant => merchant.id !== action.payload
                )
            };
        case FETCH_P24_MERCHANT_BY_ID:
            return {
                ...state,
                p24MerchantById: action.payload
            };
        case FETCH_P24_MERCHANTS_BY_NIP:
            return {
                ...state,
                p24MerchantsByTaxId: action.payload
            };
        case FETCH_P24_MERCHANTS_BY_PESEL:
            return {
                ...state,
                p24MerchantsByTaxId: action.payload
            };
        case FETCH_P24_MERCHANTS_BY_P24_MERCHANT_ID:
            return {
                ...state,
                p24MerchantsByTaxId: action.payload
            };
        case TEST_CONNECTION_P24_MERCHANT: {
            return {
                ...state,
                p24MerchantTestConnection: action.payload
            };
        }
        case FETCH_P24_MERCHANT_PAYMENT_METHODS: {
            return {
                ...state,
                p24MerchantPaymentMethodList: action.payload
            };
        }
        default:
            return state;
    }
}